module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-switch"
  }, [_c('div', {
    staticClass: "site-switch__current",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentLocation)
    }
  }), _vm._v(" Location\n        "), _c('span', {
    staticClass: "site-switch__chevron"
  })]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "site-switch__options"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "site-switch__option",
      domProps: {
        "innerHTML": _vm._s(option.name)
      },
      on: {
        "click": function($event) {
          _vm.gotosite(option.url)
        }
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f98b00e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/SiteSwitch.vue
// module id = 37
// module chunks = 1